import type { Order } from 'Types/generic';

export const MOCK_ITEMS = [
	{
		status: 'Interactive div row',
		vehicle: 'Kia',
		won: '£100,000',
	},
	{
		status: 'Interactive anchor row',
		vehicle: 'BMW',
		won: '£2',
	},
	{
		status: 'Interactive row',
		vehicle: 'Dacia',
		won: '£1M',
	},
];

export const SORT_ARIA_MAP: Record<Order, 'ascending' | 'descending'> = {
	ASC: 'ascending',
	DESC: 'descending',
};

export const DEFAULT_COLUMN_TEXT_ALIGNMENT = 'left';

export const DEFAULT_COLUMN_SORTABLE = false;

export const DEFAULT_ARIA_INDEX_OFFSET = 1;
export const BODY_ROW_ARIA_INDEX_OFFSET = 2;
